<div class="linear-result-model-header__title-all">
    <div class="linear-result-model-header__title">{{ title }}</div>

    @if (subtitle) {
        <span class="linear-result-model-header__subtitle">{{ separator }} {{ subtitle }}</span>
    }
</div>

<div class="linear-result-model-header__odds">
    @if (odds) {
        <bs-result-odds [odds]="odds" [boostedOdds]="boostedOdds" [oddsDisplayFormat]="oddsDisplayFormat" [withAnimation]="false" />
    }
</div>

@if (odds) {
    <span class="linear-result-model-header__separator"></span>
}

<span class="linear-result-model-header__toggle-icon" [ngClass]="expanded ? 'theme-up' : 'theme-down'"></span>
